import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import OrthodonticWithoutPaidContainer from 'app/containers/Accounting/OrthodonticWithoutPaid'

const OrthodonticWithoutPaidContainerCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.orthodontic_patient_scheduling_density)}</PageTitle>
      <OrthodonticWithoutPaidContainer />
    </>
  )
}
const AccountingOrthodonticWithoutPaid = memo(
  OrthodonticWithoutPaidContainerCpn,
  isEqual,
)

export default AccountingOrthodonticWithoutPaid
